import { render, staticRenderFns } from "./IdTagSticker.vue?vue&type=template&id=475b9406&scoped=true&"
import script from "./IdTagSticker.vue?vue&type=script&lang=ts&"
export * from "./IdTagSticker.vue?vue&type=script&lang=ts&"
import style0 from "./IdTagSticker.vue?vue&type=style&index=0&id=475b9406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b9406",
  null
  
)

export default component.exports